import React from "react";
import {
  Container,
  Wrapper,
  Image,
  Title,
  Link,
} from "../../library/components";
import Logo from "../../assets/logo_lbg.svg";
import Twitter from "../../assets/icon-twitter.svg";
import Instagram from "../../assets/instagram.svg";
import Linkedin from "../../assets/LinkedIn.svg";

const Footer = () => {
  return (
    <div
      style={{
        borderTop: "1px",
        borderBottom: "1px",
        borderLeft: 0,
        borderRight: 0,
        borderStyle: "solid",
        borderColor: "rgba(43, 41, 45, .6)",
      }}
    >
      <Container>
        <Wrapper justify="space-between">
          <Image src={Logo} />

          {/* <Title size="22px" color="#2B292D">Products</Title>
                        
                        <Title size="22px" color="#2B292D">Company</Title> */}
        </Wrapper>
      </Container>
      <div
        style={{
          borderTop: "1px",
          borderBottom: "1px",
          borderLeft: 0,
          borderRight: 0,
          borderStyle: "solid",
          borderColor: "rgba(43, 41, 45, .2)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            maxWidth: "976px",
            margin: "auto",
          }}
        >
          <div
            style={{
              width: "180px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 2rem",
            }}
          >
            {/* <Link size="14px" color="rgba(43, 41, 45, .6)">Terms</Link>
                            <Link size="14px" color="rgba(43, 41, 45, .6)">Privacy</Link>
                            <Link size="14px" color="rgba(43, 41, 45, .6)">License</Link> */}
          </div>
          <div
            style={{
              width: "100px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 2rem",
            }}
          >
            <Image
              onClick={() => window.location.replace("https://twitter.com/")}
              src={Twitter}
            />
            <Image
              onClick={() => window.location.replace("https://instagram.com/")}
              src={Instagram}
            />
            <Image
              onClick={() =>
                window.location.replace("https://www.linkedin.com/")
              }
              src={Linkedin}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
